import React from 'react';
// import ReactTooltip from 'react-tooltip';
import { Table } from 'react-bootstrap';
// Button,
import { useHistory } from 'react-router-dom';
// , Link
//import { Link } from "react-router-dom";

//import { user_access_level, apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
// import { apiUrl, owner_perms, org_friendly_url, user_access_level, user_account_level, organization_user_access_level, user_entity_uuid } from "Api/Api";
// import axios from "axios";

import { local_routes } from 'utils/Routes';

import UserContext from 'store/UserContext';

import { get_current_unix_stamp } from "utils/Helper.js";

import ChatCallButton from 'components/ChatCallButton/ChatCallButton';

//import { Widget, addResponseMessage, toggleWidget } from 'react-chat-widget';

import cloneDeep from 'lodash/cloneDeep';
//import './style.css';

const last_active_lookback_time = 90; // seconds

function FriendsComponent (props) {
  const user_context = React.useContext(UserContext);
  const history = useHistory();

  const [friends,setFriends] = React.useState([]);
  const [context_user_type,setContextUserType] = React.useState(props.user_type || 'friends');
  
  //const [assets_array, setAssetsArray] = React.useState([]);

  // on mount / props change
  React.useEffect(() => {
    if (!user_context.user_info[context_user_type]) {
      return;
    }

    console.log("FriendsComponent useEffect props,user_context",props,user_context.user_info[context_user_type]);
    
    let tmp_friends = [];
    Object.values(user_context.user_info[context_user_type]).forEach( element => {
      if (element.is_online && element.last_active_time > (get_current_unix_stamp() - last_active_lookback_time)) {
        tmp_friends.push(cloneDeep(element));
      } else {
        //console.log(" WTF",element.last_active_time,get_current_unix_stamp());
      }
    });
    //Object.values(user_context.user_info[context_user_type]).filter( element => (element.is_online && element.last_active_time > (get_current_unix_stamp() - 900)) );

    /*
    tmp_friends.forEach( element => {
      // fix avatar image to be small
      if (element.avatar_image_url) {
        let array = element.avatar_image_url.split("/");
        element.adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
      }
    });
    */
    setFriends(tmp_friends);
    
  }, [user_context]);

  function handleFriendClick(user_info) {
    history.push(local_routes.users+'/'+user_info.friendly_url);
  }
  
  const handleNewUserMessage = async (newMessage) => {
    console.log(`New message incoming! ${newMessage}`);
    // Now send the message throught the backend API
  };


  return (
    <React.Fragment>
      { user_context.user_info.entity_uuid &&
        <Table
          striped
          //bordered
          hover
          variant={user_context.theme === 'dark' ? 'dark' : ''}
        >
          <thead>
            <tr>
              <th>
                <span style={{ }}>{context_user_type === 'friends' ? 'Friends' : 'Admins'}</span>
              </th>
              <th>
              </th>
            </tr>
          </thead>
          <tbody>
          { friends.map( user_element => (
            <tr key={user_element.entity_uuid}>
              <td style={{ cursor: "pointer" }} onClick={() => handleFriendClick(user_element)}>
                
                { user_element.adjusted_image_url &&
                  <img className="img-fluid rounded-circle" style={{ marginRight: "10px" }} width="25px" height="25px" src={user_element.adjusted_image_url} alt="friend avatar image" />
                }
                <span style={{ fontSize: "larger" }}>{user_element.entity_name}</span>
                
              </td>
              {/*
              <td style={{ textAlign: "right" }}>
                <Button
                  onClick={toggleWidget}
                  //entity_info={user_element}
                >
                  TXT
                </Button>
              </td>
              */}
              <td style={{ textAlign: "right" }}>
                <ChatCallButton
                  entity_info={user_element}
                />
              </td>
            </tr>
          ))}
          </tbody>
        </Table>
      }
      {/*
                          <Widget
                            handleNewUserMessage={handleNewUserMessage}
                            profileAvatar={user_context.user_info.adjusted_image_url || null}
                            title="My new awesome title"
                            subtitle="And my cool subtitle"
                            chatId={1}
                          />
      */}
    </React.Fragment>
    
  );
}

export default FriendsComponent;